import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getMessageFormatter } from "../../Redux/AvailableUsers/mentions/selectors";

const useFormattedMessage = (text: string, emailOnlyMentions?: Dictionary<boolean>) => {
    const formatter = useSelector(getMessageFormatter);
    const message = useMemo(() => formatter.format(text, emailOnlyMentions), [text, formatter, emailOnlyMentions]);

    return [message] as const;
};

export { useFormattedMessage };
